export default [
    {
        path: 'lancamento-resultado',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-lancamento-resultado' */
            '@/views/exame-laboratorial/lancamento-resultado/Index'
        ),
        redirect: 'lancamento-resultado/index',
        children: [
            {
                name: 'exame-laboratorial-lancamento-resultado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-lancamento-resultado' */
                    '@/views/exame-laboratorial/lancamento-resultado/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-lancamento-resultado-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-lancamento-resultado' */
                    '@/views/exame-laboratorial/lancamento-resultado/Form.vue'
                ),
            },
        ],
    }
]